export const USER_LOGIN = "USER_LOGIN_IN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_SIGN_UP = "USER_SIGN_UP";
export const USER_VERIFY = "USER_VERIFIED";